import React, { useEffect } from 'react';

// Styles
import './styles/globals.css';

// Components - Fixed versions
import SimpleNavbar from './components/SimpleNavbar';
import HeroSection from './components/HeroSection';
import TestimonialsSection from './components/TestimonialsSection';
import EmergencySection from './components/EmergencySection';
import ContactSection from './components/ContactSection';
import MapSection from './components/MapSection';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import InstalacionesSection from './components/InstalacionesSection';

// Custom hooks
import useScrollAnimations from './hooks/useScrollAnimations';

function App() {
  // Initialize scroll animations
  useScrollAnimations();

  // Set document title
  useEffect(() => {
    document.title = 'CEV24 - Clínica de Emergencias Veterinarias 24/7';
  }, []);

  return (
    <div className="font-sans bg-impacto">
      {/* Navigation */}
      <SimpleNavbar />
      {/* Main Content */}
      <main>
        <HeroSection />
        <ServicesSection />
        <InstalacionesSection />
        <AboutSection />
        <TestimonialsSection />
        <EmergencySection />
        <ContactSection />
        <MapSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* WhatsApp Float Button */}
      <WhatsAppFloat />
    </div>
  );
}

export default App;
